module.exports = __webpack_public_path__ + "static/media/sharing-casting-icon.3dbbc16c.svg";